var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "drag-and-drop-container",
      attrs: { for: "file-drag-and-drop", "data-active": _vm.draggingInZone },
      on: {
        drop: function ($event) {
          $event.preventDefault()
          return _vm.dropFile.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.handleEnterInZone.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.handleLeaveZone.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "jade-text",
        {
          staticClass: "pointer-events-none text-center",
          attrs: {
            color: _vm.draggingInZone ? "positive" : "medium",
            weight: "semibold",
          },
        },
        [_vm._v(_vm._s(_vm.$t("drag-and-drop.title")))]
      ),
      _c(
        "jade-text",
        {
          staticClass: "text-center pointer-events-none",
          attrs: { color: "medium", variant: "small" },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("instructions", { limit: _vm.limit })) + " "
          ),
        ]
      ),
      _c(
        "jade-button",
        {
          staticClass: "pointer-events-none",
          attrs: {
            variant: "neutral-subtle",
            size: "medium",
            icon: "action-export",
          },
        },
        [_vm._v(_vm._s(_vm.$t("upload.button")))]
      ),
      _c("input", {
        ref: "file",
        staticClass: "hidden",
        attrs: {
          id: "file-drag-and-drop",
          type: "file",
          multiple: _vm.multiple,
        },
        on: { change: _vm.onChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }